import { MessageCircle, Clock, AlertTriangle, UserCheck } from "lucide-react";
import { formatDuration, formatNumber } from "../../../../utils/format";
import { cn } from "../../../../../../utils/utils";

const Card = ({ icon: Icon, label, value, hint, tone = "default", loading }) => {
  const toneClasses = {
    default: "bg-white",
    danger: "bg-red-50 border-red-200",
    warning: "bg-amber-50 border-amber-200",
    success: "bg-emerald-50 border-emerald-200",
  };
  if (loading) {
    return (
      <div className="rounded-xl border border-gray-200 bg-white p-4 animate-pulse">
        <div className="h-3 w-20 bg-gray-100 rounded mb-3" />
        <div className="h-8 w-24 bg-gray-200 rounded" />
        <div className="h-3 w-32 bg-gray-100 rounded mt-2" />
      </div>
    );
  }
  return (
    <div
      className={cn(
        "rounded-xl border border-gray-200 p-4 transition-colors",
        toneClasses[tone] || toneClasses.default,
      )}
    >
      <div className="flex items-center gap-2 text-gray-500 text-xs mb-2">
        <Icon size={14} />
        <span className="uppercase tracking-wide font-medium">{label}</span>
      </div>
      <div className="text-3xl font-semibold text-gray-900 tabular-nums leading-tight">
        {value}
      </div>
      {hint && <div className="text-xs text-gray-500 mt-1.5">{hint}</div>}
    </div>
  );
};

const HeroKpiStrip = ({ data, loading }) => {
  const unresolved = Number(data?.unresolvedCount || 0);
  const timeouts = Number(data?.timeoutCount || 0);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <Card
        icon={MessageCircle}
        label="Hội thoại mới"
        value={formatNumber(data?.newConversations || 0)}
        hint={`${formatNumber(data?.customerMessages || 0)} tin khách · ${formatNumber(
          data?.adminMessages || 0,
        )} tin NV`}
        loading={loading}
      />
      <Card
        icon={Clock}
        label="FRT P50"
        value={formatDuration(data?.frtP50Seconds)}
        hint={`P95 ${formatDuration(data?.frtP95Seconds)} · ${formatNumber(
          data?.frtSampleSize || 0,
        )} mẫu`}
        loading={loading}
      />
      <Card
        icon={AlertTriangle}
        label="Đang kẹt"
        value={formatNumber(unresolved)}
        hint={timeouts > 0 ? `${formatNumber(timeouts)} quá SLA` : "Không có quá SLA"}
        tone={timeouts > 0 ? "danger" : unresolved > 0 ? "warning" : "default"}
        loading={loading}
      />
      <Card
        icon={UserCheck}
        label="Trả lời TB"
        value={formatDuration(data?.frtAvgSeconds)}
        hint="Thời gian phản hồi trung bình"
        loading={loading}
      />
    </div>
  );
};

export default HeroKpiStrip;
